const theme = {
    colors: {
        white: '#fff',
        bg: '#ebddc0',
        primary: '#2c1901',
        second: '#894200',
    },
}

export default theme